let FintreeConfig = {
  baseAPIEndpoint: import.meta.env.VITE_APP_BASE_API_ENDPOINT,
};

export default FintreeConfig;
